const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
};

const cardSwatchStates = new WeakMap();
const boundCardSwatches = new WeakSet();
const cardProductRequests = new Map();

const getCardProduct = (handle) => {
  if (!cardProductRequests.has(handle)) {
    const request = new Promise((resolve, reject) => {
      jQuery.getJSON(
        window.Shopify.routes.root + `products/${handle}.js`,
        resolve
      ).fail(reject);
    }).catch((error) => {
      cardProductRequests.delete(handle);
      throw error;
    });
    cardProductRequests.set(handle, request);
  }
  return cardProductRequests.get(handle);
};

const cardSwatchKey = (input) =>
  input ? `${input.dataset.optionPosition}:${input.value}` : "";

const cardImageKey = (src) => {
  const url = new URL(src, window.location.href);
  return url.pathname + (url.searchParams.get("v") || "");
};

const syncCardSwatch = (wrapper, input) => {
  if (!input || !input.checked) return;

  if (input.dataset.variantLink) {
    wrapper
      .querySelectorAll(".js-color-swatches-link, .card__title > a")
      .forEach((link) => link.setAttribute("href", input.dataset.variantLink));
  }

  const primaryImage = wrapper.querySelector(".media--first");
  const state = cardSwatchStates.get(wrapper);
  const key = cardSwatchKey(input);
  const colorOptionIndex = Number(input.dataset.optionPosition) - 1;
  if (!primaryImage || !state || !Number.isInteger(colorOptionIndex) || colorOptionIndex < 0) return;
  if (state.key === key && state.image === primaryImage && state.src === primaryImage.src) return;
  if (state.pending && state.pending.key === key && state.pending.image === primaryImage) return;

  const pending = { key, image: primaryImage };
  state.pending = pending;
  getCardProduct(wrapper.dataset.product).then((product) => {
    if (!input.checked || !primaryImage.isConnected || state.pending !== pending) return;
    const variant = product.variants.find(
      (item) => item.featured_media && item.options[colorOptionIndex] === input.value
    );
    if (!variant) return;

    const media = variant.featured_media;
    const imageKey = cardImageKey(media.preview_image.src);
    let displayedImage = primaryImage;
    if (cardImageKey(primaryImage.src) !== imageKey) {
      const secondaryImage = wrapper.querySelector(".media--second");
      if (secondaryImage && cardImageKey(secondaryImage.src) === imageKey) {
        primaryImage.remove();
        secondaryImage.classList.remove("media--second");
        secondaryImage.classList.add("media--first");
        displayedImage = secondaryImage;
      } else {
        displayedImage = createImageElement(
          media, primaryImage.className, primaryImage.sizes, product.title
        );
        primaryImage.replaceWith(displayedImage);
        displayedImage.animate(
          { opacity: [0, 1] },
          { duration: 200, easing: "ease-in" }
        );
        if (secondaryImage) secondaryImage.remove();
      }
    }
    state.key = key;
    state.image = displayedImage;
    state.src = displayedImage.src;
  }).catch(() => {}).finally(() => {
    if (state.pending === pending) state.pending = null;
  });
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    const inputs = [...wrapper.querySelectorAll(".js-color-swatches input[data-color-swatch]")];
    if (!cardSwatchStates.has(wrapper)) {
      const primaryImage = wrapper.querySelector(".media--first");
      const defaultInput = inputs.find((input) => input.defaultChecked) || inputs.find((input) => input.checked);
      cardSwatchStates.set(wrapper, {
        key: cardSwatchKey(defaultInput),
        image: primaryImage,
        src: primaryImage ? primaryImage.src : "",
        pending: null
      });
    }

    inputs.forEach((input) => {
      if (boundCardSwatches.has(input)) return;
      boundCardSwatches.add(input);
      input.addEventListener("change", () => syncCardSwatch(wrapper, input));
    });
    syncCardSwatch(wrapper, inputs.find((input) => input.checked));
  });
};

let cardSwatchRestoreTimer;
let cardSwatchLifecycleBound = false;
const restoreCardSwatches = () => {
  checkSwatches();
  window.clearTimeout(cardSwatchRestoreTimer);
  cardSwatchRestoreTimer = window.setTimeout(checkSwatches, 0);
};

function colorSwatches() {
  if (!cardSwatchLifecycleBound) {
    cardSwatchLifecycleBound = true;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", restoreCardSwatches, { once: true });
    }
    window.addEventListener("pageshow", restoreCardSwatches);
    document.addEventListener("shopify:section:load", restoreCardSwatches);
  }
  if (document.readyState !== "loading") restoreCardSwatches();
}

(function () {
  colorSwatches();
})();
